export default {
    title: "Order preview",
    cardTitle: "Credit Card",
    cashOnDeliveryTitle: "Cash on delivery",
    paymentInfo: 'These products do not have the option of paying by card. Their payment will be made by cash on delivery. You can cancel the purchase of these products on the button below.',
    priceSummary: {
        productSum: "Product sum",
        delivery: "Delivery",
        surcharge: "Surcharge",
        total: "Total"
    }
}
